<template>
  <!-- 物流公司管理 -->
  <div class="logisticsCompany">
    <!-- 面包屑导航 -->
    <crumbs-bar
      @refresh="getTableData('refresh')"
      :crumbsList="['系统设置', $route.meta.title]"
    >
      <template slot="controls">
        <el-link
          @click="explain = true"
          style="margin-right: 10px"
          icon="el-icon-question"
          :underline="false"
          type="warning"
          >操作说明</el-link
        >
        <el-button
          type="primary"
          icon="el-icon-circle-plus-outline"
          @click="handleAdd"
          >添加</el-button
        >
        <el-button type="danger" @click="handleDel()">删除</el-button>
      </template>
    </crumbs-bar>

    <!-- 搜索框 -->
    <search-bar>
      <template>
        <label class="label">状态：</label>
        <el-select
          style="width: 100px"
          v-model="searchForm.status"
          placeholder="状态"
          clearable
        >
          <el-option label="全部" value=""></el-option>
          <el-option label="启用" value="Y"></el-option>
          <el-option label="禁用" value="N"></el-option>
        </el-select>
        <el-input
          v-model="searchForm.name"
          style="width: 200px; margin-left: 10px"
          clearable
          placeholder="按名称查找"
        ></el-input>
        <el-button
          style="margin-left: 10px"
          type="primary"
          icon="el-icon-search"
          @click="getTableData()"
          >搜索</el-button
        >
      </template>
    </search-bar>

    <!-- 数据展示 -->
    <div class="main">
      <el-table
        :data="tableData"
        stripe
        border
        height="100%"
        @selection-change="selectionChange"
        tooltip-effect="dark"
      >
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column label="序号" type="index" align="center" width="50">
        </el-table-column>
        <el-table-column
          align="center"
          prop="LogisticsName"
          show-overflow-tooltip
          label="物流公司"
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="LogisticsCode"
          show-overflow-tooltip
          label="编码"
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="Status"
          show-overflow-tooltip
          label="状态"
        >
          <template slot-scope="scope">
            <el-tag type="success" v-if="scope.row.Status == 'Y'"
              >已启用</el-tag
            >
            <el-tag type="warning" v-else-if="scope.row.Status == 'N'"
              >已禁用</el-tag
            >
            <el-tag type="info" v-else-if="scope.row.Status == '0'"
              >已删除</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="isDefault"
          show-overflow-tooltip
          label="是否默认"
        >
          <template slot-scope="scope">
            <el-tag type="success" v-if="scope.row.IsDefault == 'Y'">是</el-tag>
            <el-tag type="warning" v-else>否</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="Lastmodifytime"
          show-overflow-tooltip
          label="修改时间"
        >
        </el-table-column>

        <el-table-column align="center" prop="" label="操作" width="300px">
          <template v-if="scope.row.Status != '0'" slot-scope="scope">
            <el-button
              type="text"
              icon="el-icon-edit"
              @click="handleEdit(scope.row)"
              >编辑</el-button
            >
            <!-- <el-button
              type="text"
              icon="el-icon-delete"
              @click="handleDel(scope.row)"
              >删除</el-button
            > -->
            <el-button
              v-if="scope.row.Status == 'N'"
              type="text"
              icon="el-icon-warning-outline"
              @click="changeStatus(scope.row, 'Y')"
              >启用</el-button
            >
            <el-button
              v-if="scope.row.Status == 'Y'"
              type="text"
              icon="el-icon-warning-outline"
              @click="changeStatus(scope.row, 'N')"
              >禁用</el-button
            >
            <el-button
              type="text"
              icon="el-icon-position"
              @click="handlePostage(scope)"
              >邮费管理</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 分页 -->
    <pagination
      :allPage="allPage"
      :pageSize="pageSize"
      :currIndex="currPage"
      @hanSiChange="hanSiChange"
      @hanCurrChange="hanCurrChange"
    ></pagination>

    <!-- 添加物流公司 -->
    <el-drawer
      title=""
      :visible.sync="addDrawer"
      :withHeader="false"
      :close-on-press-escape="$store.state.closeOnPresEscape"
      :wrapperClosable="$store.state.closeOnClickModal"
      direction="rtl"
    >
      <div class="drawer-header">
        <span v-if="submitType == 'add'">新增</span>
        <span v-else>编辑</span>
      </div>
      <el-scrollbar class="drawer-con">
        <div class="drawer-form-wrap">
          <el-form
            :model="addForm"
            label-position="rigth"
            label-width="120px"
            :rules="formRule"
            ref="addForm"
          >
            <el-form-item label="公司名称：" prop="LogisticsName">
              <el-input
                v-model="addForm.LogisticsName"
                style="width: 200px; margin-right: 5px"
                clearable
                placeholder="输入名称"
              ></el-input>
            </el-form-item>
            <el-form-item label="图标：" prop="ImgUrl">
              <img-view :imgList="[{ url: coverImg, id: 0 }]"></img-view>
              <upload
                style="margin-left: 20px"
                @fileChange="uploadImg"
                accept="image/jpg,image/jpeg,image/png"
                :multiple="true"
              ></upload>
            </el-form-item>
            <el-form-item label="是否默认：" prop="isDefault">
              <el-select
                v-model="addForm.isDefault"
                placeholder="请选择"
                style="width: 200px; margin-right: 5px"
              >
                <el-option label="是" value="Y"></el-option>
                <el-option label="否" value="N"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
      </el-scrollbar>
      <div class="drawer-footer">
        <el-button type="primary" @click="submitForm">确定</el-button>
        <el-button type="info" @click="clearForm">取消</el-button>
      </div>
    </el-drawer>

    <el-dialog
      title="操作说明"
      :visible.sync="explain"
      :close-on-click-modal="$store.state.closeOnClickModal"
      :close-on-press-escape="$store.state.closeOnPresEscape"
      width="70%"
    >
      <div class="explain-text">
        <p>该界面维护物流功能</p>
        <p>使用场景：用户结算时选择物流</p>
        <div>
          <p>操作说明：</p>
          <p>1、添加：新建物流公司</p>
          <p>2、邮费管理：维护不同地区的邮费金额</p>
          <p>3、启用</p>
        </div>
        <p>备注：商家如果进行自配，可不维护物流公司</p>
      </div>
    </el-dialog>
  </div>
</template>

<script>
//混入
import { mustFill } from "@/mixins/data/valid.js"; //混入表单必填项

export default {
  name: "logisticsCompany",
  data() {
    return {
      entId: "",
      /**搜索表单 */
      searchForm: {
        status: "", //Y启用N禁用
        name: "", //搜索内容
      },
      coverImg: "", // 封面图片
      /**表格数据 */
      tableData: [],
      selectedList: [], //选中的数据

      addDrawer: false /**新增drawer */,
      /**表单数据 */
      addForm: {
        LogisticsName: "", //物流公司名称
        LogisticsCode: "", //编码
        ImgUrl: "", //物流公司封面图
        isDefault: "N", //是否默认
      },
      submitType: "add", //提交类型，编辑还是新增
      /**表单验证 */
      formRule: {
        LogisticsName: [mustFill],
        isDefault: [mustFill],
      },
      /**分页数据 */
      currPage: 1,
      pageSize: 20,
      allPage: 0,

      /**使用说明 */
      explain: false,
    };
  },
  mounted() {
    this.entId = window.localStorage.getItem("entId");
    this.getTableData();
  },
  methods: {
    /**获取表格 */
    getTableData(type = "") {
      //函数太多 type: refresh search 不传参数默认加载
      if (type == "refresh") {
        this.currPage = 1;
        this.searchForm.status = "";
      } else if (type == "search") {
        this.currPage = 1;
      }

      let data = {
        entId: this.entId,
        searchVal: this.searchForm.name,
        status: this.searchForm.status, //Y启用，N禁用
        pageIndex: this.currPage,
        pageSize: this.pageSize,
      };

      this.$request({
        url: "Base/LogisticsList",
        method: "post",
        data,
      })
        .then((res) => {
          this.tableData = res.list;
          this.allPage = res.toTal;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    /**分页size改变 */
    hanSiChange(val) {
      this.pageSize = val;
      this.getTableData();
    },

    /**当前页改变 */
    hanCurrChange(val) {
      this.currPage = val;
      this.getTableData();
    },

    /**新增 */
    handleAdd() {
      this.submitType = "add";
      this.clearForm();
      this.addDrawer = true;
    },

    /**编辑 */
    handleEdit(row) {
      this.submitType = "edit";

      this.addForm.LogisticsName = row.LogisticsName;
      this.addForm.LogisticsCode = row.LogisticsCode;
      this.addForm.ImgUrl = row.ImgUrl;
      this.addForm.isDefault = row.IsDefault;
      this.coverImg = this.$setImgUrl(row.ImgUrl);

      this.addDrawer = true;
    },
    /**客户 selection change触发事件 */
    selectionChange(section) {
      //存放选中的表格数据
      this.selectedList = section;
    },
    // /**删除角色 */
    // handleDel() {
    //   if (this.selectedList.length == 1) {
    //     // this.$confirm("确定删除吗?", "提示", {
    //     //   confirmButtonText: "确定",
    //     //   cancelButtonText: "取消",
    //     //   type: "error",
    //     // })
    //     //   .then(() => {
    //     let row = this.selectedList[0];
    //     this.handleStatus(row, 0);
    //     // })
    //     // .catch(() => {});
    //   } else {
    //     this.$message({
    //       message: "只能删除一条数据",
    //       type: "warning",
    //     });
    //   }
    // },
    /**删除 */
    handleDel() {
      let row = {};
      if (this.selectedList.length == 1) {
        row = this.selectedList[0];
      } else {
        this.$message({
          message: "只能删除一条数据",
          type: "warning",
        });
      }
      this.$confirm("确定要删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$request({
            url: "Base/UpdateLogisticsStatus",
            method: "post",
            data: {
              EntId: this.entId,
              LogisticsCode: row.LogisticsCode,
              Status: "Q",
            },
          })
            .then((res) => {
              let type = res.success ? "success" : "error";
              //提示成功，关闭dialog
              this.$message({
                message: type,
                type,
              });

              if (res.success) {
                this.getTableData();
              }
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch(() => {});
    },

    /**修改状态 */
    changeStatus(row, Status) {
      //未选中判断
      this.$request({
        url: "Base/UpdateLogisticsStatus ",
        method: "post",
        data: {
          EntId: this.entId,
          LogisticsCode: row.LogisticsCode,
          Status,
        },
      })
        .then((res) => {
          let type = res.success ? "success" : "error";
          // let text = Status=='Y'?'启用成功':'禁用成功';
          //提示成功，关闭dialog
          this.$message({
            message: type,
            type,
          });

          if (res.success) {
            this.getTableData();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    /**关闭drawer 清空表单信息 */
    clearForm() {
      this.addForm = {
        LogisticsName: "",
        ImgUrl: "",
        LogisticsCode: "",
        isDefault: "N",
      };
      this.coverImg = "";
      this.addDrawer = false;
      if (this.$refs["addForm"]) {
        this.$refs["addForm"].resetFields();
      }
    },

    /**上传图片 */
    uploadImg(file) {
      if (file.length) {
        const formData = new FormData();
        formData.append("file", file[0]);
        this.$uploadRequest({
          method: "post",
          url: "admin/ashx/UploadImg.ashx?type=UploadFile&fileType=Navigation",
          data: formData,
        })
          .then((res) => {
            if (res.flag == 0) {
              this.addForm.ImgUrl = res.message;
              this.coverImg = this.$setImgUrl(res.message);
            } else {
              this.$message.error(res.message);
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },

    /**提交表单 */
    submitForm() {
      this.$refs["addForm"].validate((valid) => {
        if (valid) {
          //获取区域的编码
          let data = null;
          let url = "Base/SaveLogistics";

          if (this.submitType === "add") {
            data = {
              EntId: this.entId,
              LogisticsCode: this.addForm.LogisticsCode,
              LogisticsName: this.addForm.LogisticsName,
              ImgUrl: this.addForm.ImgUrl,
              IsDefault: this.addForm.isDefault,
            };
          } else {
            data = {
              EntId: this.entId,
              LogisticsCode: this.addForm.LogisticsCode,
              LogisticsName: this.addForm.LogisticsName,
              IsDefault: this.addForm.isDefault,
            };
          }

          this.$request({
            url,
            method: "post",
            data,
          }).then((res) => {
            let type = res.success ? "success" : "error";
            this.$message({
              message: type,
              type: type,
            });

            if (res.success) {
              //关闭drawer，清空表单，刷新数据
              this.clearForm();
              this.getTableData("refresh");
            }
          });
        } else {
          this.$message({
            message: "请补全信息",
            type: "warning",
          });
        }
      });
    },

    /**点击邮费管理，跳转到二级页面 */
    handlePostage({ row }) {
      this.$router.push({
        name: "logisticsPostage",
        params: { row },
      });
    },
  },
};
</script>

<style scoped>
.logisticsCompany {
  width: 100%;
  height: 100%;
}

/**表格容器 */
.main {
  height: calc(100% - 130px);
}

/**抽屉 */
.drawer-con {
  height: calc(100% - 90px);
}

/**表单输入框 */
.form-input {
  width: 200px;
}
</style>
